import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import { useSelector } from "react-redux";
import { RootState } from "../../redux-stores/store";
const CampaignImageSlider: React.FC<{ images: string[] }> = ({ images }) => {
    const mode = useSelector((state: RootState) => state.theme.mode);

    return (
        <Swiper pagination={true} autoplay={true} loop={images.length > 1} modules={[Pagination, Autoplay]} className="mySwiper">
            {
                images.map((image, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <div className="d-block rounded-4 w-100 mb-3" style={{
                                backgroundImage: `url(${image})`,
                                position: 'relative',
                                backgroundColor: mode === 'light' ? '#000' : '#1a1c20',
                                backgroundPosition: '50%',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'contain',
                                paddingBottom: '50%'
                            }} />
                        </SwiperSlide>
                    )
                })
            }
        </Swiper>
    )
}

export default CampaignImageSlider;